import { useEffect, useState } from "react";
import { field, PhotoItem } from "../../types";
export function useFormState(fields: field[], values: Record<string, any>) {
	const [formValues, setFormValues] = useState<Record<string, any>>({});
	const [fileValues, setFileValues] = useState<Record<number, PhotoItem[]>>({});
	const [selectValues, setSelectValues] = useState<
		Record<string, { label: string; value: string }[]>
	>({});
	useEffect(() => {
		const nextValues: Record<string, any> = {};
		const nextSelects: Record<string, { label: string; value: string }[]> = {};
		const nextFileValues: Record<string, PhotoItem[]> = {};
		for (const field of fields) {
			const key = String(field.field_key);
			if (field.field_type === "multiSelect") {
				const raw = values[key] ?? field.default_value ?? [];
				nextSelects[key] = raw.map((opt: string) => ({
					label: opt,
					value: opt
				}));
			} else if (field.field_type === "checkbox") {
				nextValues[key] = values[key] ?? field.default_value ?? [];
			} else if (field.field_type === "sub_form") {
				nextValues[key] = values[key] ?? field.default_value ?? [];
			} else if (field.field_type === "picture"){
				nextFileValues[key] = values[key]?.files ?? [];
				nextValues[key] = values[key]?.id ?? null;
			} else {
				nextValues[key] = values[key] ?? field.default_value ?? "";
			}
		}
		setFileValues(nextFileValues);
		setFormValues(nextValues);
		setSelectValues(nextSelects);
	}, [fields, values]);
	return {
		formValues, 
		setFormValues, 
		selectValues, 
		setSelectValues, 
		fileValues, 
		setFileValues
	};
}
